// extracted by mini-css-extract-plugin
export default {"miniCartHeader":"MiniCartHeader_miniCartHeader__k8XB8"};